"use client";

import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";
import { useJobsStore } from "@/stores/jobs-store";
import { useShallow } from "zustand/shallow";

export function PortfolioListItemsSkeleton() {
  const jobs = useJobsStore(
    useShallow((state) => {
      return Array.from(state.jobs.values()).filter((job) =>
        job.componentId.startsWith("portfolio-create"),
      );
    }),
  );

  return jobs.map((_job, index) => <PortfolioListItemSkeleton key={index} />);
}

export function PortfolioListItemSkeleton() {
  return (
    <div
      className={cn(
        "mb-1 flex animate-pulse flex-col gap-[0.125rem] rounded-lg border bg-primary/5 p-2 hover:bg-accent",
      )}
    >
      <Skeleton className="h-4 w-20" />
      <Skeleton className="h-5 w-20" />
    </div>
  );
}
